import { AuthEffects } from "./auth/store/auth.effects";
import { AppSearchEffects } from "./app-search/store/app-search.effects";
import { CommentsEffects } from "./comments/store/comments.effects";
import { ProductsEffects } from "./products/store/products.effects";
import { UserEffects } from "./user/store/user.effects";
import { UsersEffects } from "./users/store/users.effects";
import { ProductSearchSharedEffects } from "./product-search-shared/store/product-search-shared.effects";
import { DamEffects } from "./dam/store/dam.effects";
import { FileDownloadEffects } from "./file-attachments/file-download/store/file-download.effects";
import { ProductHistoryEffects } from "./product-history/store/product-history.effects";

export const FeatureEffects = [
  ...AuthEffects,
  ...AppSearchEffects,
  ...CommentsEffects,
  ...DamEffects,
  ...FileDownloadEffects,
  ...ProductsEffects,
  ...ProductHistoryEffects,
  ...ProductSearchSharedEffects,
  ...UserEffects,
  ...UsersEffects,
];
